import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Acesso } from 'src/app/core/acesso';
import { CarregarPerfil } from '../../../core/carregar-perfil';
import { PublicoAlvo } from '../../../core/publico-alvo';
import { PublicoAlvoService } from '../../../services/publico-alvo/publico-alvo.service';
import { ToastService } from '../../../services/toast/toast.service';

@Component({
  selector: 'cadastrar-publico-alvo',
  templateUrl: './cadastrar-publico-alvo.component.html',
  styleUrls: ['./cadastrar-publico-alvo.component.css']
})
export class CadastrarPublicoAlvoComponent implements OnInit {

  publicoAlvo: PublicoAlvo = new PublicoAlvo();

  isAtualizar: boolean = false;


  perfilAcesso: Acesso = new Acesso();
  carregarPerfil: CarregarPerfil  = new CarregarPerfil();

  mostrarBotaoCadastrar = true
  mostrarBotaoAtualizar = true;


  constructor(
    private publicoAlvoService: PublicoAlvoService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastService: ToastService
  ) {
  }


  ngOnInit() {

    this.inicializarObjetos();

    
    this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);

    if (!this.perfilAcesso.insere) {
      this.mostrarBotaoCadastrar = false;
    }

    if (!this.perfilAcesso.altera) {
      this.mostrarBotaoAtualizar = false;
    }

    let idPublicoAlvo: number;
    idPublicoAlvo = this.activatedRoute.snapshot.queryParams.id ? this.activatedRoute.snapshot.queryParams.id : null;
    if (idPublicoAlvo) {
      this.isAtualizar = true;
      this.publicoAlvoService.getById(idPublicoAlvo).subscribe((publicoAlvo: PublicoAlvo) => {
        this.publicoAlvo = publicoAlvo
      });
    }

  }
  inicializarObjetos() {
    this.publicoAlvo = new PublicoAlvo();
  }

  mostrarBotaoLimpar() {
    if (this.isAtualizar) return false;
    if (!this.mostrarBotaoAtualizar) return false;
    if (!this.mostrarBotaoCadastrar) return false;

    return true;
  }

  cadastrar() {
    this.publicoAlvoService.cadastrar(this.publicoAlvo).subscribe(() => {
      this.router.navigate(['publicosalvos']);
      this.toastService.showSucesso("Público alvo cadastrado com sucesso");
    });
  }

  limpar() {
    this.inicializarObjetos();
  }

  cancelar() {
    this.router.navigate(['publicosalvos']);
  }


  atualizar() {
    this.publicoAlvoService.alterar(this.publicoAlvo).subscribe(() => {
      this.router.navigate(['publicosalvos']);
      this.toastService.showSucesso("Público alvo atualizado com sucesso");
    });

  }

}
